import 'css-chunksrc/client/scenes/comments/loader/comment/styles.scss';export default {
  "comment": "_comment_7suax_1",
  "pending": "_pending_7suax_12",
  "avatar": "_avatar_7suax_16",
  "main": "_main_7suax_23",
  "header": "_header_7suax_33",
  "author": "_author_7suax_40",
  "role": "_role_7suax_47",
  "submissionDate": "_submissionDate_7suax_51",
  "content": "_content_7suax_57"
};